namespace RioERP.Products {
    export interface PacksForm {
        Id: Serenity.IntegerEditor;
        PackName: Serenity.StringEditor;
        Tags: Serenity.StringEditor;
    }

    export class PacksForm extends Serenity.PrefixedContext {
        static formKey = 'Products.Packs';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PacksForm.init)  {
                PacksForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(PacksForm, [
                    'Id', w0,
                    'PackName', w1,
                    'Tags', w1
                ]);
            }
        }
    }
}
